import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
              吃瓜每日榜单
            </h2>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs">
              网罗全网最新最热的娱乐八卦、社会热点、网络爆料。每日更新，新鲜大瓜，不容错过。
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500/40 flex items-center justify-center text-foreground-300 hover:text-accent-400 hover:border-accent-400 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500/40 flex items-center justify-center text-foreground-300 hover:text-accent-400 hover:border-accent-400 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500/40 flex items-center justify-center text-foreground-300 hover:text-accent-400 hover:border-accent-400 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full border border-foreground-500/40 flex items-center justify-center text-foreground-300 hover:text-accent-400 hover:border-accent-400 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="space-y-5">
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-2">
                联系地址
              </h4>
              <p className="text-foreground-300 text-sm leading-relaxed">
                北京市朝阳区望京SOHO<br />T1座1806室
              </p>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-2">
                联系电话
              </h4>
              <p className="text-foreground-300 text-sm">+86 010-8888-6666</p>
            </div>
            <div>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-2">
                电子邮箱
              </h4>
              <p className="text-foreground-300 text-sm">hello@yyweilai.com</p>
            </div>
          </div>

          <div className="flex items-start justify-end">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20office%20interior%20with%20warm%20lighting%2C%20creative%20workspace%2C%20minimal%20design%2C%20evening%20mood%2C%20cozy%20atmosphere%2C%20abstract%20composition%2C%20dark%20moody%20photography%20with%20warm%20accents&width=320&height=400&seq=footer-image-01&orientation=portrait"
              alt="吃瓜每日榜单办公室"
              className="rounded-xl w-40 md:w-52 h-48 md:h-60 object-cover"
            />
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-700/30 px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-foreground-500 text-xs">
          &copy; 2026 吃瓜每日榜单. All rights reserved.
        </p>
        <div className="flex items-center gap-5">
          <Link to="/about" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors whitespace-nowrap">
            关于我们
          </Link>
          <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors whitespace-nowrap">
            隐私政策
          </a>
          <a href="#" className="text-foreground-500 text-xs hover:text-foreground-300 transition-colors whitespace-nowrap">
            使用条款
          </a>
        </div>
      </div>
    </footer>
  );
}
